import React, { useEffect, useState, useContext } from "react";
import { useDesign } from "../../../context/contextDesign"
import { useThemeMode } from "../../../context/contextTheme";
import { useProfile } from "../../../context/contextProfile";
import { AboutUsText } from "../../../pages/__AboutUs";
import { PrivacyPolicyText } from "../../../pages/__PrivacyPolicy";
import settingsItems from "../../../config/settingsItems";
import ProfileComponent from "./profile";
import SecurityComponent from "./security";
import BillingComponent from "./billing";
import SidebarCard from "../../subscription/card";
import LoadBtn from "./loadBtn";
import "./style.css";

const ProfileCard = () => {
  const { theme } = useThemeMode();
  const {
    loadingSave,
    setCopyIp, setCopyDId,
    name, username,
    selectedItem, setSelectedItem,
    handleSaveData,
    handleSaveProfile,
    handleFileSelect,
    profilePicUrl,
    profilePicFile,
    isHovered, setIsHovered,
    setOldPassword, setNewPassword, setConfirmPassword,
    setError, setSuccess,
  } = useProfile();
  const { toggleProfileCard } = useDesign();
  const handleScroll = () => {
    setCopyIp(false);
    setCopyDId(false);
  }

  return (
    <>
      <div
        className="position-fixed top-0 start-0 w-100 h-100 z-2"
        style={{
          backgroundColor: 'rgba(52, 52, 52, 0.4)',
          zIndex: 1000
        }}>
      </div>
      <div className="profile-card position-absolute top-50 start-50 translate-middle 
        d-flex border-0 rounded-4 d-flex justify-content-left bg-white shadow-lg z-3"
        style={{
          height: 680, width: 1000,
          border: `1px solid ${theme.border}`,
          zIndex: 1000
        }}>
        <div className="col-4 px-4"
          style={{
            borderRadius: `1rem 0 0 1rem`,
            borderRight: `1px solid ${theme.border}`,
            background: theme.background,
            // color: theme.textColor
          }}>
          <div className="d-flex flex-row py-5 px-3"
            style={{ color: theme.textColor }}>
            <i className="bi bi-gear-fill"
              style={{
                fontSize: '20px',
                paddingRight: 10
              }} />
            <h5>Settings</h5>
          </div>
          <div className="d-flex flex-column">
            {settingsItems.map((button, index) => (
              <button
                key={index}
                className={`btn border-0 mb-2
                  ${selectedItem === button.item ? 'active ' : ''}`}
                style={{
                  fontSize: '16px', outline: 0,
                  background: selectedItem === button.item ? theme.secondary : 'transparent',
                  transition: 'all 0.3s',
                  lineHeight: 2
                }} onClick={() => setSelectedItem(button.item)}>
                <div
                  className='d-flex justify-content-left align-content-center px-2'
                  style={{
                    width: 100,
                    color: selectedItem === button.item ? theme.textColorInv : theme.textColor
                  }}>
                  <i className={`${selectedItem === button.item ? button.iconfill : button.icon} me-3`} />
                  {button.item}
                </div>
              </button>
            ))}
            <hr className="mt-5" />
            <SidebarCard />
          </div>
        </div>
        <div className="col-8 d-flex flex-column align-items-left px-5 pt-3">
          <form>
            <div className="mb-2 mt-2 d-flex flex-row justify-content-start align-items-center position-relative">
              <div className="profile-pic-wrapper" style={{ position: "relative" }}>
                <img
                  src={profilePicUrl}
                  alt=""
                  width={100}
                  height={100}
                  className="rounded-circle profile-card-image"
                />
                {/* <div
                  className="profile-overlay"
                  onClick={() => document.getElementById("file-input").click()}
                  style={{
                    position: "absolute",
                    bottom: "0px",
                    right: "0px",
                    background: "#000000a0",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <i className="bi bi-camera" style={{ color: "#fff", fontSize: "16px" }}></i>
                </div>
                <input
                  type="file"
                  id="file-input"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                /> */}
              </div>
              <div className="d-flex flex-column ps-3" style={{ lineHeight: 0.6 }}>
                <div className="h3">{name}</div>
                <div className="">@{username}</div>
              </div>
            </div>

            {profilePicFile && (
              <button
                className="btn btn-primary mt-2"
                onClick={handleSaveProfile}
                style={{ width: "120px" }}
              >
                {loadingSave ? "Saving..." : "Save Image"}
              </button>
            )}

            <hr />
            <div className="overflow-y-auto px-1"
              style={{ height: 430 }}
              onScroll={handleScroll}
            >
              {selectedItem === 'Profile' && <ProfileComponent />}
              {selectedItem === 'Security' && <SecurityComponent />}
              {selectedItem === 'Privacy' && <PrivacyPolicyText />}
              {selectedItem === 'Billing' && <BillingComponent />}
              {selectedItem === 'About' && <AboutUsText />}
            </div>
            <div className="position-absolute bottom-0 end-0 px-5 py-3">
              <button className="btn btn-primary border-0 my-3"
                type="submit"
                style={{
                  backgroundColor: 'rgb(52 66 102)',
                  fontSize: '14px', fontWeight: 600,
                  width: 150, height: 40,
                }}
                onClick={handleSaveData}
              >
                {loadingSave ? <LoadBtn /> : "Save Changes"}
              </button>
            </div>
          </form>
        </div>
        <div
          className="position-absolute top-0 end-0 px-2 py-1 m-3 fs-4 rounded-3 settings-close"
          onClick={() => {
            toggleProfileCard();
            setConfirmPassword('');
            setNewPassword('');
            setOldPassword('');
            setError('');
            setSuccess('');
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            cursor: 'pointer',
            opacity: isHovered ? 0.5 : 1,
            color: theme.textColor,
            background: isHovered ? theme.disabled : ''
          }}
        >
          <i className="bi bi-x-lg" />
        </div>
      </div>
    </>
  );
};
export default ProfileCard;
